const Init = () => {

    if( document.getElementById('other_recipes') != null ){

      // 「その他のレシピ」項目 URI照合して同一のものにcurrentクラス追加
      const path = location.pathname;
      const targets = document.getElementById('recipes_list').querySelectorAll('li');
      const targetNode = Array.prototype.slice.call( targets, 0 );

      targetNode.forEach( ( e, i ) => {
        const href = e.getElementsByTagName('a')[0].getAttribute('href');
        if ( href == path ){
          e.classList.add('current');
        }
      });

    }

}

export default Init;
